import React from "react";
import { useLocation } from "react-router-dom";
import Seo from "./Seo";
import { staticPageMeta, legacyPathAliases, isNoindexPath, SITE_NAME } from "../../seo/siteMeta";

// Applies the page title/description for every route except product pages (handled in ProductDetails).
const RouteSeo = () => {
    const { pathname, search } = useLocation();
    const lowerPath = pathname.toLowerCase().replace(/\/+$/, "") || "/";

    if (lowerPath.startsWith("/product/")) return null;

    if (isNoindexPath(lowerPath)) {
        return <Seo robots="noindex, nofollow" />;
    }

    const canonicalPath = legacyPathAliases[lowerPath] || lowerPath;
    const meta = staticPageMeta[canonicalPath];

    // /shop/<keyword> shows search results: same page title as the shop, but not worth indexing
    if (!meta && lowerPath.startsWith("/shop/")) {
        const shop = staticPageMeta["/shop"];
        return <Seo title={shop.title} description={shop.description} path="/shop" robots="noindex, follow" />;
    }

    if (!meta) {
        // Unknown URL (404 / search-keyword path): keep it out of the index.
        return <Seo title={`Page Not Found | ${SITE_NAME}`} robots="noindex, follow" />;
    }

    // Filtered shop views (?category=, ?gender=, ?sale= ...) duplicate /shop, so they canonicalise to it and stay out of the index.
    if (canonicalPath === "/shop" && search) {
        const params = new URLSearchParams(search);
        const title = params.get("sale") === "true" ? `Sale | ${SITE_NAME}` : meta.title;
        return <Seo title={title} description={meta.description} path="/shop" robots="noindex, follow" />;
    }

    return <Seo title={meta.title} description={meta.description} path={canonicalPath} />;
};

export default RouteSeo;
